module.exports = "<p>\n  stay-signin works!\n</p>\n"